import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Drobečková navigace" className="max-w-[1400px] mx-auto px-5 md:px-10 pt-24 md:pt-28" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm text-charcoal/60">
        <li><Link to="/" className="hover:text-burgundy">Úvod</Link></li>
        {items.map((it, i) => (
          <React.Fragment key={i}>
            <ChevronRight size={14} className="text-charcoal/30" />
            <li>
              {it.to ? (
                <Link to={it.to} className="hover:text-burgundy">{it.label}</Link>
              ) : (
                <span className="text-charcoal" aria-current="page">{it.label}</span>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
}
